"use strict";
exports.__esModule = true;
var react_hooks_1 = require("@apollo/react-hooks");
var queries_1 = require("../queries");
function useGetEvent(code) {
    return react_hooks_1.useQuery(queries_1.GET_EVENT, {
        variables: { code: code }
    });
}
exports.useGetEvent = useGetEvent;
//# sourceMappingURL=use-get-event.js.map